export const CATEGORY_PRESETS = {
  prc1: { // 재료입고
    eventTypes: ['ObjectEvent'],
    actions: ['add'],
    bizSteps: ['RECEIVING'],
    dispositions: ['IN_PROGRESS'],
  },
  prc3: { // 조립
    eventTypes: ['TransformationEvent'],
    actions: [],
    bizSteps: ['ASSEMBLING'],
    dispositions: ['IN_PROGRESS'],
  },
  prc4: { // 품질검사
    eventTypes: ['ObjectEvent'],
    actions: ['add'],
    bizSteps: ['INSPECTING'],
    dispositions: ['ACTIVE'],
  },
  prc5: { // 포장준비
    eventTypes: ['ObjectEvent'],
    actions: ['add'],
    bizSteps: ['COMMISSIONING'],
    dispositions: ['ACTIVE'],
  },
  prc6: { // 제품포장
    eventTypes: ['AggregationEvent'],
    actions: ['add'],
    bizSteps: ['PACKING'],
    dispositions: ['IN_PROGRESS'],
  },
  prc7: { // 출고
    eventTypes: ['ObjectEvent'],
    actions: ['add'],
    bizSteps: ['SHIPPING'],
    dispositions: ['IN_TRANSIT'],
  },
  prc8: { // 운송
    eventTypes: ['ObjectEvent'],
    actions: ['add'],
    bizSteps: ['TRANSPORTING'],
    dispositions: ['IN_TRANSIT'],
  },
  prc9: { // 판매점입고
    eventTypes: ['ObjectEvent'],
    actions: ['add'],
    bizSteps: ['RECEIVING'],
    dispositions: ['AVAILABLE'],
  },
};